import { Col, Row } from "antd";
import * as React from "react";
import ListMenu from "../../components/common/ConfigMenu/ListMenu";
import SetUpMemnu from "../../components/common/ConfigMenu/SetUpMemnu";
import { useSelector } from "react-redux";
import { configMenuSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import { resetNotifyMenu } from "../../services/slice/ConfigMenuSlice";

const MenuConfig = () => {
  const [type, setType] = React.useState(0);
  const menuState = useSelector(configMenuSelector);
  return (
    <div style={{ width: "100%" }}>
      <Notify
        type={menuState.typeNotify}
        isNotify={menuState.isNotify}
        reset={resetNotifyMenu}
        title={"Bkav Pro"}
        content={menuState.msg}
      />
      <Row style={{ width: "100%" }}>
        <Col span={6} xl={9} lg={10}>
          <ListMenu type={type} setType={setType} />
        </Col>
        <Col span={18} xl={15} lg={14}>
          {" "}
          <SetUpMemnu setType={setType} type={type} />
        </Col>
      </Row>
    </div>
  );
};

export default MenuConfig;
